import fan from './fan';
import slidingDoor from './slidingDoor';

export default {
  fan,
  slidingDoor
}
